(function () {
  "use strict";

  angular.module("appback").controller("DashboardController", DashboardController);

  DashboardController.$inject = ["$http", "$timeout", "$interval", "$scope", "Upload"];

  // Cada cuánto se refresca sola la información del dashboard (KPIs, acciones
  // de IA, canales, conversaciones pendientes...), sin que el usuario tenga
  // que recargar la página.
  var REFRESH_INTERVAL_MS = 30000;

  // El estado del Mensaje sigue en EN_ANALISIS_IA hasta que la propia IA
  // responde (ver DashboardController::actionRetryAiAnalysis()), así que el
  // botón "Reintentar análisis de IA" seguiría visible y clickeable de
  // inmediato después de cada reintento si no se deshabilita un rato por su
  // cuenta: este cooldown (por conversation.id, ver vm.retryingAi) evita que
  // un usuario dispare reintentos sin límite mientras espera la respuesta.
  var RETRY_AI_COOLDOWN_MS = 60000;

  // Id de la última ejecución de programación que el usuario ha marcado como
  // vista en el panel "Programaciones de workflow": las posteriores salen
  // como nuevas. Es solo una comodidad de este navegador (localStorage): si
  // no está disponible, todas salen como nuevas.
  var SCHEDULE_RUNS_SEEN_KEY = "dashboard.scheduleRuns.lastSeen";

  function DashboardController($http, $timeout, $interval, $scope, Upload) {
    var vm = this;

    // Pestaña activa del dashboard (ver backend/views/site/roles/admin.php):
    // operativa, resumen, paises, distribuidores o productos.
    vm.tab = "operativa";
    vm.searchQuery = "";
    vm.kpis = [];
    vm.aiActions = [];
    vm.scheduleRuns = [];
    vm.scheduleRunsLastSeen = readScheduleRunsLastSeen();
    vm.expandedRuns = {};
    vm.responseTimes = { average: "", days: [] };
    vm.channels = [];
    vm.connectedChannels = [];
    vm.conversations = [];
    vm.conversationsPage = 1;
    vm.conversationsPageSize = 10;
    vm.conversationsTotal = 0;
    vm.retryingAi = {};

    vm.tarjeta = emptyTarjeta();
    vm.tarjetaResult = { success: false, message: "" };

    vm.replyDraft = emptyReplyDraft();
    vm.contactAssign = emptyContactAssign();
    vm.simulate = emptySimulate();
    vm.workflowTasks = [];
    vm.workflow = emptyWorkflow();

    vm.acceptAction = acceptAction;
    vm.rejectAction = rejectAction;
    vm.toggleEdit = toggleEdit;
    vm.isNewRun = isNewRun;
    vm.newRunsCount = newRunsCount;
    vm.markRunsSeen = markRunsSeen;
    vm.toggleRun = toggleRun;
    vm.saveEdit = saveEdit;
    vm.replyToConversation = replyToConversation;
    vm.discardConversation = discardConversation;
    vm.confirmDiscardConversation = confirmDiscardConversation;
    vm.retryAiAnalysis = retryAiAnalysis;
    vm.confirmRetryAiAnalysis = confirmRetryAiAnalysis;
    vm.insertSuggestedReply = insertSuggestedReply;
    vm.toggleReplyNote = toggleReplyNote;
    vm.submitReply = submitReply;
    vm.conversationsTotalPages = conversationsTotalPages;
    vm.goToConversationsPage = goToConversationsPage;
    vm.openAssignContact = openAssignContact;
    vm.searchContacts = searchContacts;
    vm.assignExistingContact = assignExistingContact;
    vm.newContact = newContact;
    vm.editContact = editContact;
    vm.cancelContactForm = cancelContactForm;
    vm.saveAndAssignContact = saveAndAssignContact;
    vm.showContactSearch = showContactSearch;
    vm.cancelContactSearch = cancelContactSearch;
    vm.isValidEmail = isValidEmail;
    vm.openSimulateMessage = openSimulateMessage;
    vm.searchSimulateContacts = searchSimulateContacts;
    vm.pickSimulateContact = pickSimulateContact;
    vm.clearSimulateContact = clearSimulateContact;
    vm.submitSimulateMessage = submitSimulateMessage;
    vm.uploadTarjeta = uploadTarjeta;
    vm.openWorkflowModal = openWorkflowModal;
    vm.addWorkflowStep = addWorkflowStep;
    vm.removeWorkflowStep = removeWorkflowStep;
    vm.moveWorkflowStepUp = moveWorkflowStepUp;
    vm.moveWorkflowStepDown = moveWorkflowStepDown;
    vm.saveWorkflow = saveWorkflow;

    activate();

    function activate() {
      var discardModalEl = document.getElementById("discardConfirmModal");
      if (discardModalEl) {
        discardModalEl.addEventListener("hidden.bs.modal", function () {
          pendingDiscard = null;
        });
      }

      var retryAiModalEl = document.getElementById("retryAiConfirmModal");
      if (retryAiModalEl) {
        retryAiModalEl.addEventListener("hidden.bs.modal", function () {
          pendingRetryAi = null;
        });
      }

      loadDashboardData();

      var refreshTimer = $interval(function () {
        // Si hay un popup abierto (responder, asignar contacto, simular
        // mensaje) no se refresca: pisaría lo que el usuario está
        // escribiendo ahí adentro.
        if (isAnyModalOpen()) {
          return;
        }
        loadDashboardData();
      }, REFRESH_INTERVAL_MS);

      $scope.$on("$destroy", function () {
        $interval.cancel(refreshTimer);
      });
    }

    function loadDashboardData() {
      httpGet("/backend/dashboard/kpis").then(function (res) {
        vm.kpis = res.data;
      });

      // No se refresca si el usuario está editando la respuesta sugerida de
      // alguna acción de IA: perdería lo que escribió ahí.
      if (!vm.aiActions.some(isEditing)) {
        httpGet("/backend/dashboard/ai-actions").then(function (res) {
          vm.aiActions = res.data;
        });
      }

      httpGet("/backend/dashboard/schedule-runs").then(function (res) {
        vm.scheduleRuns = res.data;
      });

      httpGet("/backend/dashboard/response-times").then(function (res) {
        vm.responseTimes = res.data;
        renderResponseTimesChart(res.data);
      });

      httpGet("/backend/dashboard/channels").then(function (res) {
        vm.channels = res.data;
        renderChannelsChart(res.data);
      });

      httpGet("/backend/dashboard/connected-channels").then(function (res) {
        vm.connectedChannels = res.data;
      });

      loadConversations();
    }

    function isEditing(action) {
      return !!action.editing;
    }

    function readScheduleRunsLastSeen() {
      try {
        return parseInt(window.localStorage.getItem(SCHEDULE_RUNS_SEEN_KEY), 10) || 0;
      } catch (e) {
        return 0;
      }
    }

    function isNewRun(run) {
      return run.id > vm.scheduleRunsLastSeen;
    }

    function newRunsCount() {
      return vm.scheduleRuns.filter(isNewRun).length;
    }

    function markRunsSeen() {
      vm.scheduleRuns.forEach(function (run) {
        vm.scheduleRunsLastSeen = Math.max(vm.scheduleRunsLastSeen, run.id);
      });
      try {
        window.localStorage.setItem(SCHEDULE_RUNS_SEEN_KEY, String(vm.scheduleRunsLastSeen));
      } catch (e) {
        // Sin localStorage, se marcan como vistas solo hasta recargar.
      }
    }

    // Se guarda por id y no en el propio run: el refresco periódico
    // reemplaza vm.scheduleRuns y cerraría lo que el usuario tiene abierto.
    function toggleRun(run) {
      vm.expandedRuns[run.id] = !vm.expandedRuns[run.id];
    }

    function isAnyModalOpen() {
      return ["replyConversationModal", "assignContactModal", "simulateMessageModal", "workflowModal"].some(function (id) {
        var el = document.getElementById(id);
        return el && el.classList.contains("show");
      });
    }

    // ignoreLoadingBar: la misma opción que usa vendor/alt120/altcrm para que
    // el refresco periódico (y en general, todas las peticiones del
    // dashboard) no dispare la barra de carga global en cada tick.
    function httpGet(url, params) {
      return $http.get(url, { params: params, ignoreLoadingBar: true });
    }

    function loadConversations() {
      return httpGet("/backend/dashboard/conversations", {
        page: vm.conversationsPage,
        pageSize: vm.conversationsPageSize,
      }).then(function (res) {
        vm.conversations = res.data.items || [];
        vm.conversationsTotal = res.data.total || 0;
        vm.conversationsPage = res.data.page || 1;
        vm.conversationsPageSize = res.data.pageSize || vm.conversationsPageSize;
      });
    }

    function conversationsTotalPages() {
      return Math.max(1, Math.ceil(vm.conversationsTotal / vm.conversationsPageSize));
    }

    function goToConversationsPage(page) {
      if (page < 1 || page > conversationsTotalPages()) {
        return;
      }
      vm.conversationsPage = page;
      loadConversations();
    }

    function acceptAction(action) {
      postForm("/backend/dashboard/accept-ai-action", { id: action.id }).then(function () {
        vm.aiActions = vm.aiActions.filter(function (a) {
          return a.id !== action.id;
        });
      });
    }

    function rejectAction(action) {
      postForm("/backend/dashboard/reject-ai-action", { id: action.id }).then(function () {
        vm.aiActions = vm.aiActions.filter(function (a) {
          return a.id !== action.id;
        });
      });
    }

    function toggleEdit(action) {
      action.editing = !action.editing;
    }

    function saveEdit(action) {
      postForm("/backend/dashboard/update-ai-action", {
        id: action.id,
        suggestedReply: action.suggestedReply,
      }).then(function () {
        action.editing = false;
      });
    }

    function postForm(url, data) {
      return $http.post(url, jQuery.param(data), {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        ignoreLoadingBar: true,
      });
    }

    // -- Chart.js (cargado como CDN global en backend\assets\AppAsset::$js,
    // antes que este bundle) para "Tendencias de Tiempo de Respuesta" y
    // "Mensajes por Canal". Se instancian una sola vez contra el <canvas> y
    // después solo se actualizan datos + colores, en vez de recrearlos en
    // cada refresco.

    var BRAND_SECONDARY = "#4b41e1";
    var BRAND_TERTIARY = "#4edea3";

    var responseTimesChart = null;

    function renderResponseTimesChart(data) {
      var canvas = document.getElementById("responseTimesChart");
      if (!canvas || typeof Chart === "undefined") {
        return;
      }

      var days = data.days || [];
      var labels = days.map(function (d) {
        return d.label;
      });
      var values = days.map(function (d) {
        return d.hours;
      });
      var colors = days.map(function (d) {
        return d.highlight ? BRAND_SECONDARY : BRAND_TERTIARY;
      });

      if (responseTimesChart) {
        responseTimesChart.data.labels = labels;
        responseTimesChart.data.datasets[0].data = values;
        responseTimesChart.data.datasets[0].backgroundColor = colors;
        responseTimesChart.update();
        return;
      }

      responseTimesChart = new Chart(canvas.getContext("2d"), {
        type: "bar",
        data: {
          labels: labels,
          datasets: [{ data: values, backgroundColor: colors, borderRadius: 4, maxBarThickness: 32 }],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: false },
            tooltip: { callbacks: { label: function (ctx) { return ctx.parsed.y + "h"; } } },
          },
          scales: {
            y: { beginAtZero: true, ticks: { stepSize: 1 } },
            x: { grid: { display: false } },
          },
        },
      });
    }

    var channelsChart = null;

    function renderChannelsChart(channels) {
      var canvas = document.getElementById("channelsChart");
      if (!canvas || typeof Chart === "undefined") {
        return;
      }

      channels = channels || [];
      var labels = channels.map(function (c) {
        return c.name;
      });
      var values = channels.map(function (c) {
        return c.percent;
      });
      var colors = channels.map(function (c) {
        return c.color || BRAND_SECONDARY;
      });

      if (channelsChart) {
        channelsChart.data.labels = labels;
        channelsChart.data.datasets[0].data = values;
        channelsChart.data.datasets[0].backgroundColor = colors;
        channelsChart.update();
        return;
      }

      channelsChart = new Chart(canvas.getContext("2d"), {
        type: "bar",
        data: {
          labels: labels,
          datasets: [{ data: values, backgroundColor: colors, borderRadius: 4, maxBarThickness: 18 }],
        },
        options: {
          indexAxis: "y",
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: false },
            tooltip: { callbacks: { label: function (ctx) { return ctx.parsed.x + "%"; } } },
          },
          scales: {
            x: { beginAtZero: true, max: 100, ticks: { callback: function (v) { return v + "%"; } } },
            y: { grid: { display: false } },
          },
        },
      });
    }

    function emptyReplyDraft() {
      return {
        conversation: null,
        text: "",
        note: "",
        showNote: false,
        suggestedReply: null,
        opportunity: null,
        activity: [],
        thread: [],
        role: null,
        senderAddress: null,
        avatarUrl: null,
        loading: false,
      };
    }

    function replyToConversation(conversation) {
      vm.replyDraft = emptyReplyDraft();
      vm.replyDraft.conversation = conversation;
      vm.replyDraft.loading = true;
      getReplyModal().show();

      httpGet("/backend/dashboard/conversation-detail", { id: conversation.id }).then(function (res) {
        vm.replyDraft.suggestedReply = res.data.suggestedReply;
        vm.replyDraft.opportunity = res.data.opportunity;
        vm.replyDraft.activity = res.data.activity || [];
        vm.replyDraft.thread = res.data.thread || [];
        vm.replyDraft.role = res.data.role;
        vm.replyDraft.senderAddress = res.data.senderAddress;
        vm.replyDraft.avatarUrl = res.data.avatarUrl;
        vm.replyDraft.loading = false;
      });
    }

    function insertSuggestedReply() {
      if (vm.replyDraft.suggestedReply) {
        vm.replyDraft.text = vm.replyDraft.suggestedReply;
      }
    }

    function toggleReplyNote() {
      vm.replyDraft.showNote = !vm.replyDraft.showNote;
    }

    function submitReply() {
      var conversation = vm.replyDraft.conversation;
      var reply = (vm.replyDraft.text || "").trim();
      if (!conversation || reply === "") {
        return;
      }

      postForm("/backend/dashboard/reply-conversation", {
        id: conversation.id,
        reply: reply,
        note: vm.replyDraft.note || "",
      }).then(function () {
        vm.searchQuery = "";
        getReplyModal().hide();
        // Se recarga la página actual en vez de sacar la conversación del
        // array local: así el total y la cantidad de páginas quedan
        // correctos (puede entrar otra conversación a completar el hueco).
        loadConversations();
      });
    }

    var discardConfirmModal = null;
    var pendingDiscard = null;

    function getDiscardConfirmModal() {
      if (!discardConfirmModal) {
        discardConfirmModal = new bootstrap.Modal(document.getElementById("discardConfirmModal"));
      }
      return discardConfirmModal;
    }

    function discardConversation(conversation) {
      if (!conversation) {
        return;
      }

      pendingDiscard = conversation;
      getDiscardConfirmModal().show();
    }

    function confirmDiscardConversation() {
      if (!pendingDiscard) {
        return;
      }

      var conversation = pendingDiscard;
      pendingDiscard = null;
      getDiscardConfirmModal().hide();

      postForm("/backend/dashboard/discard-conversation", { id: conversation.id }).then(function () {
        loadConversations();
      });
    }

    var retryAiConfirmModal = null;
    var pendingRetryAi = null;

    function getRetryAiConfirmModal() {
      if (!retryAiConfirmModal) {
        retryAiConfirmModal = new bootstrap.Modal(document.getElementById("retryAiConfirmModal"));
      }
      return retryAiConfirmModal;
    }

    function retryAiAnalysis(conversation) {
      if (!conversation || vm.retryingAi[conversation.id]) {
        return;
      }

      pendingRetryAi = conversation;
      getRetryAiConfirmModal().show();
    }

    function confirmRetryAiAnalysis() {
      if (!pendingRetryAi || vm.retryingAi[pendingRetryAi.id]) {
        return;
      }

      var conversation = pendingRetryAi;
      pendingRetryAi = null;
      getRetryAiConfirmModal().hide();

      vm.retryingAi[conversation.id] = true;

      postForm("/backend/dashboard/retry-ai-analysis", { id: conversation.id })
        .then(function () {
          loadConversations();
        })
        .finally(function () {
          $timeout(function () {
            delete vm.retryingAi[conversation.id];
          }, RETRY_AI_COOLDOWN_MS);
        });
    }

    var replyModal = null;

    function getReplyModal() {
      if (!replyModal) {
        replyModal = new bootstrap.Modal(document.getElementById("replyConversationModal"));
      }
      return replyModal;
    }

    function emptyContactAssign() {
      return {
        conversation: null,
        currentContact: null,
        loadingCurrent: false,
        showSearch: false,
        query: "",
        results: [],
        searching: false,
        saving: false,
        form: null,
      };
    }

    var contactSearchTimeout = null;
    var assignContactModal = null;

    function getAssignContactModal() {
      if (!assignContactModal) {
        assignContactModal = new bootstrap.Modal(document.getElementById("assignContactModal"));
      }
      return assignContactModal;
    }

    function openAssignContact(conversation) {
      vm.contactAssign = emptyContactAssign();
      vm.contactAssign.conversation = conversation;
      getAssignContactModal().show();

      if (conversation.contactoId) {
        loadCurrentContact(conversation.contactoId);
      } else {
        vm.contactAssign.showSearch = true;
      }
    }

    function loadCurrentContact(contactoId) {
      vm.contactAssign.loadingCurrent = true;
      httpGet("/backend/contacto/getcontact", { id: contactoId })
        .then(function (res) {
          if (res.data.success && res.data.data) {
            vm.contactAssign.currentContact = contactSummaryFromNode(res.data.data);
          }
        })
        .finally(function () {
          vm.contactAssign.loadingCurrent = false;
        });
    }

    function contactSummaryFromNode(c) {
      var nombre = (c.nombre || "").trim();
      var apellidos = (c.apellidos || "").trim();

      return {
        id: c.id,
        nombre: nombre,
        apellidos: apellidos,
        empresa: c.empresa || "",
        email: c.email || "",
        telefono: c.telefono || "",
        initials: ((nombre.charAt(0) || "") + (apellidos.charAt(0) || "")).toUpperCase() || "—",
      };
    }

    function showContactSearch() {
      vm.contactAssign.showSearch = true;
      vm.contactAssign.query = "";
      vm.contactAssign.results = [];
    }

    function cancelContactSearch() {
      vm.contactAssign.showSearch = false;
    }

    function searchContacts() {
      if (contactSearchTimeout) {
        $timeout.cancel(contactSearchTimeout);
      }

      contactSearchTimeout = $timeout(function () {
        var query = (vm.contactAssign.query || "").trim();
        if (query === "") {
          vm.contactAssign.results = [];
          return;
        }

        vm.contactAssign.searching = true;
        httpGet("/backend/dashboard/search-contacts", { q: query })
          .then(function (res) {
            vm.contactAssign.results = res.data.data || [];
          })
          .finally(function () {
            vm.contactAssign.searching = false;
          });
      }, 300);
    }

    function assignExistingContact(contact) {
      finishAssignContact(contact.id);
    }

    function newContact() {
      vm.contactAssign.form = {
        id: null,
        nombre: (vm.contactAssign.query || "").trim(),
        apellidos: "",
        empresa: "",
        email: "",
        telefono: "",
      };
    }

    function editContact(contact) {
      vm.contactAssign.form = angular.copy(contact);
    }

    function cancelContactForm() {
      vm.contactAssign.form = null;
    }

    function isValidEmail(email) {
      email = (email || "").trim();
      return email === "" || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    function saveAndAssignContact() {
      var form = vm.contactAssign.form;
      if (!form || !(form.nombre || "").trim() || !isValidEmail(form.email)) {
        return;
      }

      vm.contactAssign.saving = true;
      postForm("/backend/dashboard/save-contact", form)
        .then(function (res) {
          if (res.data.success) {
            finishAssignContact(res.data.data.id);
          }
        })
        .finally(function () {
          vm.contactAssign.saving = false;
        });
    }

    function finishAssignContact(contactoId) {
      var conversation = vm.contactAssign.conversation;
      if (!conversation) {
        return;
      }

      postForm("/backend/dashboard/assign-contact", {
        id: conversation.id,
        contactoId: contactoId,
      }).then(function (res) {
        if (res.data.success) {
          getAssignContactModal().hide();
          loadConversations();
        }
      });
    }

    function emptyTarjeta() {
      return {
        uploading: false,
      };
    }

    var tarjetaResultModal = null;

    function getTarjetaResultModal() {
      if (!tarjetaResultModal) {
        tarjetaResultModal = new bootstrap.Modal(document.getElementById("tarjetaResultModal"));
      }
      return tarjetaResultModal;
    }

    // El botón "Subir tarjeta de visita" abre directo el selector de
    // archivo (sin popup de por medio, ver admin.php): al elegir la foto se
    // sube directo a backend\controllers\ContactoController::actionSubirtarjeta()
    // sin ningún Contacto en contexto (backend\models\ContactoTarjetaForm::
    // subir() crea uno nuevo en blanco cuando no llega id) y solo al
    // terminar se muestra el popup de resultado.
    function uploadTarjeta(input) {
      if (!input.files || !input.files[0]) {
        return;
      }

      var file = input.files[0];
      input.value = "";

      vm.tarjeta.uploading = true;

      // Upload.upload() (ngFileUpload, ya cargado en appback) en vez de
      // $http + FormData a mano: eso mandaba la petición con Content-Type
      // application/json en vez de multipart/form-data, así que
      // $_FILES['file'] llegaba vacío al backend. Mismo patrón que ya usa
      // backend/web/js/fields/tarjetalectura.controller.js para subir una
      // tarjeta a /backend/contacto/readcard.
      Upload.upload({
        url: "/backend/contacto/subirtarjeta",
        data: { file: file },
      })
        .then(function (res) {
          vm.tarjetaResult = {
            success: !!res.data.success,
            message: res.data.msg || "La tarjeta se ha enviado para procesar.",
          };
        })
        .catch(function () {
          vm.tarjetaResult = { success: false, message: "No se ha podido subir la tarjeta de visita." };
        })
        .finally(function () {
          vm.tarjeta.uploading = false;
          getTarjetaResultModal().show();
        });
    }

    function emptySimulate() {
      return {
        channelUserId: null,
        contact: null,
        query: "",
        results: [],
        searching: false,
        asunto: "",
        mensaje: "",
        sending: false,
        error: null,
      };
    }

    var simulateSearchTimeout = null;
    var simulateMessageModal = null;

    function getSimulateMessageModal() {
      if (!simulateMessageModal) {
        simulateMessageModal = new bootstrap.Modal(document.getElementById("simulateMessageModal"));
      }
      return simulateMessageModal;
    }

    function openSimulateMessage() {
      vm.simulate = emptySimulate();
      getSimulateMessageModal().show();
    }

    function searchSimulateContacts() {
      if (simulateSearchTimeout) {
        $timeout.cancel(simulateSearchTimeout);
      }

      simulateSearchTimeout = $timeout(function () {
        var query = (vm.simulate.query || "").trim();
        if (query === "") {
          vm.simulate.results = [];
          return;
        }

        vm.simulate.searching = true;
        httpGet("/backend/dashboard/search-contacts", { q: query })
          .then(function (res) {
            vm.simulate.results = res.data.data || [];
          })
          .finally(function () {
            vm.simulate.searching = false;
          });
      }, 300);
    }

    function pickSimulateContact(contact) {
      vm.simulate.contact = contact;
      vm.simulate.query = "";
      vm.simulate.results = [];
    }

    function clearSimulateContact() {
      vm.simulate.contact = null;
    }

    function submitSimulateMessage() {
      var simulate = vm.simulate;
      if (!simulate.channelUserId || !simulate.contact || !(simulate.mensaje || "").trim()) {
        return;
      }

      simulate.sending = true;
      simulate.error = null;

      postForm("/backend/dashboard/simulate-message", {
        channelUserId: simulate.channelUserId,
        contactoId: simulate.contact.id,
        asunto: simulate.asunto || "",
        mensaje: simulate.mensaje,
      })
        .then(function (res) {
          if (res.data.success) {
            getSimulateMessageModal().hide();
            loadConversations();
          } else {
            simulate.error = res.data.msg || "No se ha podido simular el mensaje.";
          }
        })
        .catch(function () {
          simulate.error = "No se ha podido simular el mensaje.";
        })
        .finally(function () {
          simulate.sending = false;
        });
    }

    function emptyWorkflow() {
      return { activo: true, steps: [], loading: false, saving: false, saved: false, error: null };
    }

    var workflowModal = null;

    function getWorkflowModal() {
      if (!workflowModal) {
        workflowModal = new bootstrap.Modal(document.getElementById("workflowModal"));
      }
      return workflowModal;
    }

    // Botón a la izquierda de "Simular" en "Conversaciones Pendientes": abre
    // el popup para definir, en orden, qué frontend\components\task\*
    // ejecuta Hermes sobre cada mensaje entrante (ver
    // backend\models\HermesWorkflowForm). Las tareas disponibles
    // (dc.workflowTasks, {slug, description}) se piden una sola vez, no en
    // cada apertura.
    function openWorkflowModal() {
      vm.workflow = emptyWorkflow();
      vm.workflow.loading = true;
      getWorkflowModal().show();

      if (!vm.workflowTasks.length) {
        httpGet("/backend/dashboard/workflow-tasks").then(function (res) {
          vm.workflowTasks = res.data.data || [];
        });
      }

      httpGet("/backend/dashboard/workflow-get")
        .then(function (res) {
          vm.workflow.activo = !!res.data.data.activo;
          vm.workflow.steps = res.data.data.steps || [];
        })
        .catch(function () {
          vm.workflow.error = "No se ha podido cargar el workflow.";
        })
        .finally(function () {
          vm.workflow.loading = false;
        });
    }

    function addWorkflowStep() {
      vm.workflow.steps.push({ slug: vm.workflowTasks.length ? vm.workflowTasks[0].slug : "", orden: vm.workflow.steps.length + 1, condition: "" });
    }

    function removeWorkflowStep(index) {
      vm.workflow.steps.splice(index, 1);
    }

    function moveWorkflowStepUp(index) {
      if (index <= 0) {
        return;
      }
      var steps = vm.workflow.steps;
      var tmp = steps[index - 1];
      steps[index - 1] = steps[index];
      steps[index] = tmp;
    }

    function moveWorkflowStepDown(index) {
      var steps = vm.workflow.steps;
      if (index >= steps.length - 1) {
        return;
      }
      var tmp = steps[index + 1];
      steps[index + 1] = steps[index];
      steps[index] = tmp;
    }

    // El orden real que se guarda es siempre la posición en el array (ver
    // moveWorkflowStepUp/Down): así arrastrar/mover un step no puede dejar
    // "orden" desincronizado del orden visual de las cartas.
    function saveWorkflow() {
      vm.workflow.saving = true;
      vm.workflow.saved = false;
      vm.workflow.error = null;

      var steps = vm.workflow.steps.map(function (step, index) {
        return { slug: step.slug, orden: index + 1, condition: step.condition || "" };
      });

      postForm("/backend/dashboard/workflow-save", {
        activo: vm.workflow.activo ? 1 : 0,
        steps: steps,
      })
        .then(function (res) {
          if (res.data.success) {
            vm.workflow.saved = true;
          } else {
            vm.workflow.error = "No se ha podido guardar el workflow.";
          }
        })
        .catch(function () {
          vm.workflow.error = "No se ha podido guardar el workflow.";
        })
        .finally(function () {
          vm.workflow.saving = false;
        });
    }
  }
})();
